// src/components/modals/RazorpayModal.js

import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import {
  createRazorpayData,
  getRazorpayData,
} from "../../services/TenantsService";
import { toast } from "react-toastify";

const MyTenantRazorpayModal = ({ show, onClose, tenantId }) => {
  const [showKey, setShowKey] = useState(false);
  const [showSecret, setShowSecret] = useState(false);
  const [showWebhookSecret, setShowWebhookSecret] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    name: "",
    keyId: "",
    keySecret: "",
    webhookSecret: "",
  });

  console.log("hh", tenantId);

  //   const isEdit = !!tenantId;

  // PUBLIC WEBHOOK URL
  const webhookUrl = `https://api.crickpay.net/academic/v1/api/public/payments/webhook/razorpay/${tenantId}`;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getRazorpayData(tenantId);

        if (res) {
          setFormData({
            name: res.name || "",
            keyId: res.keyId || "",
            keySecret: res.keySecret || "",
            webhookSecret: res.webhookSecret || "",
          });
        }
      } catch (err) {
        console.log(err);
      }
    };

    if (show && tenantId) {
      fetchData();
    }
  }, [show, tenantId]);

  const handleReset = () => {
    setFormData({
      name: "",
      keyId: "",
      keySecret: "",
      webhookSecret: "",
    });

    setErrors({});
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Razorpay account name is required";
    }

    if (!formData.keyId.trim()) {
      newErrors.keyId = "Key ID is required";
    }

    if (!formData.keySecret.trim()) {
      newErrors.keySecret = "Key Secret is required";
    }

    if (!formData.webhookSecret.trim()) {
      newErrors.webhookSecret = "Webhook Secret is required";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    const payload = {
      name: formData.name,
      keyId: formData.keyId,
      keySecret: formData.keySecret,
      webhookSecret: formData.webhookSecret,
      tenantId: tenantId,
    };

    try {
      setLoading(true);
      const res = await createRazorpayData(payload);
      if (res) {
        toast.success("Razorpay details updated successfully");
        handleReset();
        onClose();
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to update details");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal centered size="lg" show={show} onHide={onClose}>
      <Modal.Header>
        <Modal.Title>Razorpay Details</Modal.Title>
        <Button
          variant=""
          className="btn-close"
          onClick={() => {
            handleReset();
            onClose();
          }}
        />
      </Modal.Header>

      <Modal.Body>
        <div className="row">
          {/* NAME */}

          <div className="col-md-6 mb-3">
            <label className="form-label">
              Account Name <span className="text-danger">*</span>
            </label>

            <input
              type="text"
              name="name"
              className={`form-control ${errors.name ? "is-invalid" : ""}`}
              placeholder="Enter Razorpay Account Name"
              value={formData.name}
              onChange={handleChange}
            />

            {errors.name && (
              <small className="text-danger">{errors.name}</small>
            )}
          </div>

          {/* KEY ID */}

          <div className="col-md-6 mb-3">
            <label className="form-label">
              Razorpay Key ID <span className="text-danger">*</span>
            </label>

            <div className="input-group">
              <input
                type={showKey ? "text" : "password"}
                name="keyId"
                className={`form-control ${errors.keyId ? "is-invalid" : ""}`}
                placeholder="rzp_live_xxxxxxxxx"
                value={formData.keyId}
                onChange={handleChange}
              />

              <span
                className="input-group-text"
                style={{
                  cursor: "pointer",
                }}
                onClick={() => setShowKey(!showKey)}
              >
                <i className={`fa ${showKey ? "fa-eye" : "fa-eye-slash"}`} />
              </span>
            </div>

            {errors.keyId && (
              <small className="text-danger">{errors.keyId}</small>
            )}
          </div>

          {/* KEY SECRET */}

          <div className="col-md-6 mb-3">
            <label className="form-label">
              Razorpay Key Secret <span className="text-danger">*</span>
            </label>

            <div className="input-group">
              <input
                type={showSecret ? "text" : "password"}
                name="keySecret"
                className={`form-control ${
                  errors.keySecret ? "is-invalid" : ""
                }`}
                placeholder="Enter Key Secret"
                value={formData.keySecret}
                onChange={handleChange}
              />

              <span
                className="input-group-text"
                style={{
                  cursor: "pointer",
                }}
                onClick={() => setShowSecret(!showSecret)}
              >
                <i className={`fa ${showSecret ? "fa-eye" : "fa-eye-slash"}`} />
              </span>
            </div>

            {errors.keySecret && (
              <small className="text-danger">{errors.keySecret}</small>
            )}
          </div>

          {/* WEBHOOK SECRET */}

          <div className="col-md-6 mb-3">
            <label className="form-label">
              Webhook Secret <span className="text-danger">*</span>
            </label>

            <div className="input-group">
              <input
                type={showWebhookSecret ? "text" : "password"}
                name="webhookSecret"
                className={`form-control ${
                  errors.webhookSecret ? "is-invalid" : ""
                }`}
                placeholder="Enter Webhook Secret"
                value={formData.webhookSecret}
                onChange={handleChange}
              />

              <span
                className="input-group-text"
                style={{
                  cursor: "pointer",
                }}
                onClick={() => setShowWebhookSecret(!showWebhookSecret)}
              >
                <i
                  className={`fa ${
                    showWebhookSecret ? "fa-eye" : "fa-eye-slash"
                  }`}
                />
              </span>
            </div>

            {errors.webhookSecret && (
              <small className="text-danger">{errors.webhookSecret}</small>
            )}
          </div>

          {/* WEBHOOK URL */}

          {/* WEBHOOK URL */}

          <div className="col-12">
            <div className="alert alert-info border-0 rounded-4 mt-2">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <div className="fw-semibold text-dark">
                  Razorpay Webhook URL
                </div>

                <button
                  type="button"
                  className="btn btn-primary btn-sm d-flex align-items-center justify-content-center"
                  onClick={() => {
                    navigator.clipboard.writeText(webhookUrl);
                    toast.success("Webhook URL copied");
                  }}
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "10px",
                  }}
                >
                  <i className="fa fa-copy" />
                </button>
              </div>

              <div
                className="bg-white border rounded-3 p-3 text-break"
                style={{
                  fontSize: "14px",
                  color: "#334155",
                  lineHeight: "1.6",
                }}
              >
                {webhookUrl}
              </div>

              <small className="text-muted d-block mt-2">
                Add this URL in Razorpay Dashboard → Webhooks
              </small>
            </div>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button
          className="btn btn-primary"
          disabled={loading}
          onClick={handleSubmit}
        >
          Save
        </Button>

        <Button
          variant="danger light"
          onClick={() => {
            handleReset();
            onClose();
          }}
          disabled={loading}
        >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MyTenantRazorpayModal;
